import React, { useEffect, useRef, useState } from "react";
import { showErrorToast } from "../../assets/toastUtils";
import "./FilterSection.css";
import CustomRangeSlider from "../CustomComponentsRev/CustomRangeSlider/CustomRangeSlider";
import styles from "./NewFilterActivities.module.scss";
import { FilterIcon } from "../../utils/svgIcons";

function NewFilterActivities({ sendDataToParent, showDestinations }) {
  const handleReset = () => {
    setDestinationArray([]);
    setSelectedBudget("");
    setDurationArray([]);
    setMinMax({ min: "", max: "" });
    setNoOfNights(0);
  };

  const overlayRef = useRef(null);

  const [isOpenBudget, setIsOpenBudget] = useState(false);
  const [isOpenCategory, setIsOpenCategory] = useState(true);
  const [isOpenDestination, setIsOpenDestination] = useState(true);
  const [isOpenThemes, setIsOpenThemes] = useState(true);
  const [noOfNights, setNoOfNights] = useState("");
  const [isOpenDuration, setIsOpenDuration] = useState(true);
  const [themesArray, setThemesArray] = useState([]);
  const [selectedThemesArray, setSelectedThemesArray] = useState([]);

  const fetchThemesDetails = (token) => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/themes/list`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        // console.log(data, 'themes');
        if (data.success) {
          setThemesArray(data?.themes);
        } else {
          // console.log("Error fetching data");////////////////////////////
        }
      })
      .catch((error) => {
        console.error("Error fetching  details:", error);
      });
  };

  useEffect(() => {
    fetchThemesDetails();
  }, []);

  const toggleAccordionBudget = () => {
    setIsOpenBudget(!isOpenBudget);
  };
  const toggleAccordionCategory = () => {
    setIsOpenCategory(!isOpenCategory);
  };
  const toggleAccordionDestination = () => {
    setIsOpenDestination(!isOpenDestination);
  };
  const toggleAccordionThemes = () => {
    setIsOpenThemes(!isOpenThemes);
  };

  const toggleAccordionDuration = () => {
    setIsOpenDuration(!isOpenDuration);
  };
  const handleCheckboxChange = () => {};
  // sam work start

  const [destinationArray, setDestinationArray] = useState([]);
  const [selectedBudget, setSelectedBudget] = useState("");
  const [durationArray, setDurationArray] = useState([]);
  const [minMax, setMinMax] = useState({
    min: "",
    max: "",
  });

  const handleBudgetChange = (value) => {
    setMinMax((prevMinMax) => ({
      min: "",
      max: "",
    }));
    setSelectedBudget(value);
  };

  const handleDurationCheckboxChange = (category) => {
    setNoOfNights("");
    setDurationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };
  const handleDestinationHandleChange = (category) => {
    setDestinationArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };
  const handleThemesHandleChange = (category) => {
    setSelectedThemesArray((prevArray) => {
      if (prevArray.includes(category)) {
        return prevArray.filter((item) => item !== category);
      } else {
        return [...prevArray, category];
      }
    });
  };

  // console.log(destinationArray, "destinationArray");

  useEffect(() => {
    const data = {
      budget: selectedBudget,
      duration: durationArray,
      destinations: destinationArray,
      noOfNights: noOfNights,
      themes: selectedThemesArray,
    };

    sendDataToParent(data);
  }, [
    selectedBudget,
    durationArray,
    destinationArray,
    noOfNights,
    selectedThemesArray,
  ]);

  const handleBudgetChangeMinMax = (value) => {
    // console.log(value, "value");
    const { min, max } = value;
    if (Number(min) > Number(max)) {
      showErrorToast("Please Enter Valid Budget Range");
      return;
    }
    setSelectedBudget(`${min}-${max}`);
  };

  const onValuesChange = (data) => {
    setDurationArray([]);
    setNoOfNights(data);
  };

  const [modifyPkg, setModiyPkg] = useState(false);
  const [mobileHead, setMobileHead] = useState(false);
  const toggleModify = () => {
    setModiyPkg(!modifyPkg);
  };

  const closePopup = () => {
    setModiyPkg(false);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setMobileHead(true);
    } else {
      setMobileHead(false);
    }
  }, []);

  const sendingData = {
    budget: selectedBudget,
    duration: durationArray,
    destinations: destinationArray,
    noOfNights: noOfNights,
  };

  const handleClickOutsideClosePopup = (e) => {
    if (
      window.innerWidth > 768 &&
      overlayRef.current &&
      !overlayRef.current.contains(e.target)
    ) {
      setIsOpenDestination(false);
      setIsOpenDuration(false);
      setIsOpenBudget(false);
    }


    if(window.innerWidth < 768){
      setIsOpenBudget(true);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutsideClosePopup);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideClosePopup);
    };
  }, []);




  return (
    <>
      <div ref={overlayRef} className={styles.filters_mobile_wrapper}>
      <div className={styles.filters_mobile_parent}>
          <button onClick={toggleModify}>
            <FilterIcon />
            Filters
          </button>
        </div>
        {modifyPkg && (
          <div className="filters p_0" id="mobileFilters">
            <div className="p_20">
              <svg
                onClick={closePopup}
                width="14"
                height="13"
                viewBox="0 0 14 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M1 12.5L13 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
                <path d="M13 12.5L1 0.5" stroke="#AAAAAA" strokeWidth="1.2" />
              </svg>
            </div>
            <div className="agent border-bottom-one">
              <h4>Filter</h4>
              <div className="buttons m_0">
                <button
                  className="primary_btn"
                  onClick={handleReset}
                  style={{ width: "50px", backgroundColor: "#016937" }}
                >
                  Reset
                </button>
              </div>
            </div>
            <div className="filter_checkbox border-bottom-one">
              <h6
                className="flex_align_center justify_content_between"
                onClick={toggleAccordionBudget}
                style={{ cursor: "pointer" }}
              >
                <b>
                  Budget
                </b>
                <svg
                  width="10"
                  height="8"
                  viewBox="0 0 13 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    transition: "transform 0.5s",
                  transform: isOpenBudget ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                >
                  <path
                    d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                    stroke="#222222"
                    strokeWidth="1.5"
                  />
                </svg>
              </h6>
              {isOpenBudget && (
                <div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      checked={"0-500" === selectedBudget}
                      value={"0-500"}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="0-500"
                    />
                    <label htmlFor="0-500">0 to ₹500</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"500-1500"}
                      checked={"500-1500" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="500-1500"
                    />
                    <label htmlFor="500-1500">₹500 to ₹1500</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"1500-3000"}
                      checked={"1500-3000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="1500-3000"
                    />
                    <label htmlFor="1500-3000">₹1500 to ₹3000</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"3000-5000"}
                      checked={"3000-5000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="3000-5000"
                    />
                    <label htmlFor="3000-5000">₹3000 to 5000</label>
                  </div>
                  <div className="flex pt_10">
                    <input
                      type="radio"
                      value={"5000-15000"}
                      checked={"5000-15000" === selectedBudget}
                      onChange={(e) => handleBudgetChange(e.target.value)}
                      id="5000-15000"
                    />
                    <label htmlFor="5000-15000">₹5000 to 15000</label>
                  </div>
                  {/* <div>
                      <strong style={{ marginTop: "10px", display: "block" }}>
                        Your Budget
                      </strong>
                      <div className="filter_your_budget_parent">
                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Min"
                            id="min"
                            name="min"
                            value={minMax.min}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, min: e.target.value });
                            }}
                          />
                        </span>
                        <span>to</span>

                        <span className="filter_your_budget">
                          <input
                            // disabled={selectedBudget ? true : false}
                            type="number"
                            placeholder="Max"
                            id="max"
                            name="max"
                            value={minMax.max}
                            onChange={(e) => {
                              setSelectedBudget("");
                              setMinMax({ ...minMax, max: e.target.value });
                            }}
                          />
                        </span>

                        <button
                          onClick={() => handleBudgetChangeMinMax(minMax)}
                          className="icon_btn"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="#fff"
                          >
                            <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                          </svg>
                        </button>
                      </div>
                      
                    </div> */}
                </div>
              )}
            </div>

            <div className="apply_btn">
              <button
                onClick={() => {
                  sendDataToParent(sendingData);
                  setModiyPkg(false);
                }}
                style={{ backgroundColor: "#016937" }}
                className="primary_btn"
              >
                <h4>Apply Now</h4>
              </button>
            </div>
          </div>
        )}
      </div>

      <div className={styles.filters_wrapper}>
        <div ref={overlayRef} className={styles.filters}>
          <div  className={styles.filter_div} id="overlay">
            <div
              className={styles.filter_heading_parent}
              onClick={toggleAccordionBudget}
            >
              <div className={styles.filter_heading}>Budget</div>
              <svg
                width="10"
                height="8"
                viewBox="0 0 13 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  transition: "transform 0.5s",
                  transform: isOpenBudget ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                <path
                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                  stroke="#222222"
                  strokeWidth="1.5"
                />
              </svg>
            </div>
            {isOpenBudget && (
              <div className={styles.filter_content}>
                <div
                  className={styles.clear_all}
                  onClick={() => setSelectedBudget(null)}
                >
                  Clear All
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    checked={"0-500" === selectedBudget}
                    value={"0-500"}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="0-500"
                  />
                  <label htmlFor="0-500">0 to ₹500</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"500-1500"}
                    checked={"500-1500" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="500-1500"
                  />
                  <label htmlFor="500-1500">₹500 to ₹1500</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"1500-3000"}
                    checked={"1500-3000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="1500-3000"
                  />
                  <label htmlFor="1500-3000">₹1500 to ₹3000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"3000-5000"}
                    checked={"3000-5000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="3000-5000"
                  />
                  <label htmlFor="3000-5000">₹3000 to 5000</label>
                </div>
                <div className="flex pt_10">
                  <input
                    type="radio"
                    value={"5000-15000"}
                    checked={"5000-15000" === selectedBudget}
                    onChange={(e) => handleBudgetChange(e.target.value)}
                    id="5000-15000"
                  />
                  <label htmlFor="5000-15000">₹5000 to 15000</label>
                </div>
                {/* <div>
                 <strong style={{ marginTop: "10px", display: "block" }}>
                   Your Budget
                 </strong>
                 <div className="filter_your_budget_parent">
                   <span className="filter_your_budget">
                     <input
                       // disabled={selectedBudget ? true : false}
                       type="number"
                       placeholder="Min"
                       id="min"
                       name="min"
                       value={minMax.min}
                       onChange={(e) => {
                         setSelectedBudget("");
                         setMinMax({ ...minMax, min: e.target.value });
                       }}
                     />
                   </span>
                   <span>to</span>

                   <span className="filter_your_budget">
                     <input
                       // disabled={selectedBudget ? true : false}
                       type="number"
                       placeholder="Max"
                       id="max"
                       name="max"
                       value={minMax.max}
                       onChange={(e) => {
                         setSelectedBudget("");
                         setMinMax({ ...minMax, max: e.target.value });
                       }}
                     />
                   </span>

                   <button
                     onClick={() => handleBudgetChangeMinMax(minMax)}
                     className="icon_btn"
                   >
                     <svg
                       xmlns="http://www.w3.org/2000/svg"
                       width="24"
                       height="24"
                       fill="#fff"
                     >
                       <path d="M7.293 4.707 14.586 12l-7.293 7.293 1.414 1.414L17.414 12 8.707 3.293 7.293 4.707z" />
                     </svg>
                   </button>
                 </div>
                 
               </div> */}
              </div>
            )}
          </div>
        </div>

        {/* )} */}
      </div>
    </>
  );
}
export default NewFilterActivities;
